<div class="container-fluid d-flex p-0">
  <app-side-bar></app-side-bar>
  <ng-container>
    <!-- <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;"> -->
    <div style="padding: 15px; margin: 5px;" class="main-container">
      <div style="max-width: 100%;" class="main-heading">
        <h1>Litigation DashBoard</h1>
      </div>
      <div style="display: flex;justify-content: space-between; flex-wrap: wrap;">
        <button (click)=" refreshData()" class="btn btn-primary" style="margin-bottom: 10px;">
          Refresh Data
        </button>
        <div style="display: flex;gap: 10px;">
          <button (click)="openEventManager()" class="btn btn-primary" style="margin-bottom:10px;">
            Add/Edit Events
          </button>
          <button (click)="openAppealEventManager()" class="btn btn-primary" style="margin-bottom:10px;">
            Add/Edit Appeal Case Events
          </button>
          <button (click)="openDialog()" class="btn btn-primary" style="margin-bottom: 10px;">
            + ADD
          </button>
          <button (click)="viewAllRecords()" class="btn btn-primary" style="margin-bottom: 10px;">
            View All Records
          </button>
        </div>
      </div>
      <div class="card" style="max-width: 100%;">
        <p-table #litigationdata [value]="filteredLitigationData" [(selection)]="selectedLitigationData" dataKey="_id"
          [expandedRowKeys]="expandedRowKeys" [tableStyle]="{ 'min-width': '60%' }" [paginator]="true" [rows]="pageSize"
          [first]="(page - 1) * pageSize" [showCurrentPageReport]="true" paginatorPosition="both" [scrollable]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          [rowsPerPageOptions]="[10, 50, 100]" [loading]="loading" [lazy]="true" [lazyLoadOnInit]="false"
          [totalRecords]="totalRecords" (onLazyLoad)="onLazyLoad($event)" [sortField]="sortField"
          [sortOrder]="sortOrder" [sortMode]="'single'"
          [globalFilterFields]="['Case Number', 'NDA Number', 'Brand Name', 'Plaintiff', 'Defendant', 'Filed ANDA', 'ANDA Number', 'Court Name', 'Judge', 'Field ID', 'PDF File', 'Patents at issue', 'Case Status', 'Termination Date']">
          <ng-template pTemplate="caption">
            <div class="flex" style="display: flex; justify-content: flex-end; gap: 10px;">
              <p-dropdown [options]="dropdownOptions" [(ngModel)]="selectedOption" (onChange)="onOptionChange($event)">
              </p-dropdown>
              <p-dropdown *ngIf="selectedOption === 'deleted'" [options]="deletedScopeOptions" [(ngModel)]="deletedScope"
                (onChange)="onOptionChange($event)" placeholder="Select Scope"></p-dropdown>
              <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" (onChange)="onStatusChange($event)"
                placeholder="Select Status"></p-dropdown>
              <button (click)="confirmBulkReject()" class="btn btn-danger"
                [disabled]="!selectedLitigationData || selectedLitigationData.length === 0">
                Reject Records
              </button>

              <button (click)="confirmBulkHold()" class="btn btn-warning"
                [disabled]="!selectedLitigationData || selectedLitigationData.length === 0">
                Hold Records
              </button>

              <p-calendar [(ngModel)]="startdate" dateFormat="mm/dd/yy" [showIcon]="true" placeholder="Start Date"
                (ngModelChange)="onOptionChange($event)">
              </p-calendar>

              <p-calendar [(ngModel)]="enddate" dateFormat="mm/dd/yy" [showIcon]="true" placeholder="End Date"
                (ngModelChange)="onOptionChange($event)">
              </p-calendar>

              <p-dropdown [options]="eventFilterOptions" [(ngModel)]="selectedEventFilter" placeholder="Events Filter"
                styleClass="ml-2" [showClear]="true" (onChange)="onOptionChange($event)">
              </p-dropdown>

              <button class="btn btn-primary" style="background-color: #2196F3;" (click)="clearDates()">Clear</button>

              <div style="display: flex; flex-direction: column; gap: 2px; margin-left: auto;">
                <span class="p-input-icon-left">
                  <input pInputText type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)"
                    placeholder="Search" />
                </span>
                <div style="display: flex; gap: 8px; font-size: 11px; color: #495057; justify-content: flex-end;">
                  <label
                    style="display: flex; align-items: center; gap: 3px; margin: 0; cursor: pointer; font-weight: normal;">
                    <input type="radio" name="searchScope" value="main" [(ngModel)]="searchScope" /> Main
                  </label>
                  <label
                    style="display: flex; align-items: center; gap: 3px; margin: 0; cursor: pointer; font-weight: normal;">
                    <input type="radio" name="searchScope" value="other" [(ngModel)]="searchScope" /> Other
                  </label>
                  <label
                    style="display: flex; align-items: center; gap: 3px; margin: 0; cursor: pointer; font-weight: normal;">
                    <input type="radio" name="searchScope" value="appeal" [(ngModel)]="searchScope" /> Appeal
                  </label>
                  <label
                    style="display: flex; align-items: center; gap: 3px; margin: 0; cursor: pointer; font-weight: normal;">
                    <input type="radio" name="searchScope" value="both" [(ngModel)]="searchScope" /> Both
                  </label>
                </div>
              </div>
            </div>

            <!-- Custom Dialog Start -->
            <p-dialog header="Litigation DashBoard" [(visible)]="displayReviewDialog" [modal]="true" [closable]="false"
              class="custom-dialog" style="width: 80%">
              <div class="dialog-add dialog-content">
                <div class="p-field" style="margin-bottom: 15px;">
                  <label style="font-weight: bold; color: #333; margin-bottom: 8px; display: block;">
                    Please select the type of litigation ?
                  </label>
                  <div style="display: flex; gap: 20px; align-items: center;">
                    <label
                      style="cursor: pointer; font-weight: normal; display: flex; align-items: center; gap: 5px; margin: 0;">
                      <input type="radio" name="addLitigationType" value="main" [(ngModel)]="addLitigationType"
                        (change)="onAddLitigationTypeChange()" />
                      Main Litigation
                    </label>
                    <label
                      style="cursor: pointer; font-weight: normal; display: flex; align-items: center; gap: 5px; margin: 0;">
                      <input type="radio" name="addLitigationType" value="other" [(ngModel)]="addLitigationType"
                        (change)="onAddLitigationTypeChange()" />
                      Other Litigation
                    </label>
                  </div>
                </div>

                <div class="p-field">
                  <label for="caseNumber">Case Number:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="caseNumber" required class="required-input" />
                  <div *ngIf="submitted && !caseNumber" class="error-text">
                    Case Number is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="ndaNumber">NDA Number:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="ndaNumber" required class="required-input" />
                  <div *ngIf="submitted && !ndaNumber" class="error-text">
                    NDA Number is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="brandName">Brand Name:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="brandName" required class="required-input" />
                  <div *ngIf="submitted && !brandName" class="error-text">
                    Brand name is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="plaintiff">Plaintiff:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="plaintiff" required class="required-input" />
                  <div *ngIf="submitted && !plaintiff" class="error-text">
                    Plaintiff is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="defendant">Defendant:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="defendant" required class="required-input" />
                  <div *ngIf="submitted && !defendant" class="error-text">
                    Defendant is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="filedANDA">Filed ANDA:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="filedANDA" required class="required-input"
                    [disabled]="addLitigationType === 'other'" />
                  <div *ngIf="submitted && !filedANDA && addLitigationType !== 'other'" class="error-text">
                    Filed ANDA is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="andaNumber">ANDA Number:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="andaNumber" required class="required-input"
                    [disabled]="addLitigationType === 'other'" />
                  <div *ngIf="submitted && !andaNumber && addLitigationType !== 'other'" class="error-text">
                    ANDA Number is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="courtName">Court Name:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="courtName" required class="required-input" />
                  <div *ngIf="submitted && !courtName" class="error-text">
                    Court name is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="judgeName">Judge Name:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="judgeName" required class="required-input" />
                  <div *ngIf="submitted && !judgeName" class="error-text">
                    Judge name is required.
                  </div>
                </div>

                <div class="p-field">
                  <label for="filedDate">Filed Date:</label>
                  <input id="key" type="text" pInputText [(ngModel)]="filedDate" required class="required-input" />
                  <div *ngIf="submitted && !filedDate" class="error-text">
                    Field date is required.
                  </div>
                </div>

                <div class="p-field" *ngIf="addLitigationType === 'other'">
                  <label for="addLitigationCategory">Litigation Category:</label>
                  <p-dropdown [options]="litigationCategoryOptions" [(ngModel)]="addLitigationCategory"
                    placeholder="Select Category" [style]="{ width: '100%' }">
                  </p-dropdown>
                </div>
              </div>

              <div class="p-field" style="margin-top: 10px;">
                <label for="pdfUpload" style="margin-right: 5px;">Upload PDF:</label>
                <input type="file" id="pdfUpload" accept="application/pdf" (change)="onPDFSelect($event)"
                  class="required-input pdf-upload-input" />
                <div *ngIf="pdfFile">
                  <small>Selected file: {{ pdfFile.name }}</small>
                </div>
              </div>

              <p-footer>
                <button type="button" pButton icon="pi pi-times" label="Cancel" class="cancel-btn"
                  (click)="displayReviewDialog = false"></button>
                <button type="button" pButton [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                  [label]="loading ? 'Inserting...' : 'Insert'" class="submit-btn" (click)="confirmData()"
                  [disabled]="loading">
                </button>
              </p-footer>
            </p-dialog>
            <!-- Custom Dialogue End -->
            <!-- Error message -->
            <p *ngIf="dateError" style="color: red; margin-top: 5px;text-align: center;
">
              {{ dateError }}
            </p>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 2rem" *ngIf="selectedStatus === 'pending'">
                <span class="header-container">
                  <span style="margin-right: 4px;">Reject</span>
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </span>
              </th>
              <th
                *ngIf="selectedOption === 'other_litigations' || selectedOption === 'Manual Entry' || selectedOption === 'other_litigation_appeal_cases' || selectedOption === 'deleted'"
                pSortableColumn="Litigation Category">
                <span class="header-container">
                  Litigation Category
                  <p-sortIcon field="Litigation Category"></p-sortIcon>
                </span>
              </th>
              <th>
                <span class="header-container">
                  Case Number
                </span>
              </th>
              <!-- <th pSortableColumn="NDA Number">
                <span class="header-container">
                  NDA Number
                  <p-sortIcon field="NDA Number"></p-sortIcon>
                </span>
              </th>
              <th pSortableColumn="Brand Name">
                <span class="header-container">
                  Brand Name
                  <p-sortIcon field="Brand Name"></p-sortIcon>
                </span>
              </th> -->
              <th>
                <span class="header-container">
                  NDA Number-Brand Name
                </span>
              </th>

              <th>
                <span class="header-container">
                  Plaintiffs
                </span>
              </th>
              <th>
                <span class="header-container">
                  Defendants
                </span>
              </th>
              <th>
                <span class="header-container">
                  Filed ANDA
                </span>
              </th>
              <th>
                <span class="header-container">
                  ANDA Number
                </span>
              </th>
              <th>
                <span class="header-container">
                  Court Name
                </span>
              </th>
              <th>
                <span class="header-container">
                  Judge Name
                </span>
              </th>
              <th pSortableColumn="Field ID">
                <span class="header-container">
                  Filed Date
                  <p-sortIcon field="Field ID"></p-sortIcon>
                </span>
              </th>
              <!-- <th pSortableColumn="filedDateObj">
                <span class="header-container">
                  Filed Date
                  <p-sortIcon field="filedDateObj"></p-sortIcon>
                </span>
              </th> -->

              <th>
                <span class="header-container">
                  Patents at issue
                </span>
              </th>
              <th pSortableColumn="Case Status">
                <span class="header-container">
                  Case Status
                  <p-sortIcon field="Case Status"></p-sortIcon>
                </span>
              </th>
              <th>
                <span class="header-container">
                  Related Cases
                </span>
              </th>
              <th pSortableColumn="Termination Date">
                <span class="header-container">
                  Termination Date
                  <p-sortIcon field="Termination Date"></p-sortIcon>
                </span>
              </th>
              <th>
                <span class="header-container">
                  PDF
                  <!-- <p-sortIcon field="PDF File"></p-sortIcon> -->
                </span>
              </th>
              <th *ngIf="selectedOption !== 'not_found_pdf_case_no' && selectedOption !== 'deleted'">Edit</th>
              <th>Delete</th>
              <th *ngIf="selectedStatus === 'pending'">Approve</th>
              <th>
                <span class="header-container">
                  Event
                </span>
              </th>
              <th>
                <span class="header-container">
                  Appeal Case
                </span>
              </th>
              <th *ngIf="selectedOption === 'deleted'">
                <span class="header-container">
                  Action
                </span>
              </th>
              <th>
                <span class="header-container">
                  Approved Time
                </span>
              </th>
              <th>
                <span class="header-container">
                  Edited By
                </span>
              </th>
              <th>
                <span class="header-container">
                  Last Edited
                </span>
              </th>
              <!-- <th>Approve</th> -->
              <!-- <th>On Hold</th> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td *ngIf="selectedStatus === 'pending'">
                <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
              </td>
              <td
                *ngIf="selectedOption === 'other_litigations' || selectedOption === 'Manual Entry' || selectedOption === 'other_litigation_appeal_cases' || selectedOption === 'deleted'">
                <span *ngIf="editRowId === rowData['_id']; else viewLitCategory">
                  <p-dropdown [options]="litigationCategoryOptions" [(ngModel)]="rowData['Litigation_Category']"
                    (onChange)="rowData['Litigation Category'] = $event.value" placeholder="Select Category"
                    [style]="{ 'width': '100%', 'min-width': '140px' }">
                  </p-dropdown>
                </span>
                <ng-template #viewLitCategory>
                  {{ rowData['Litigation Category'] || rowData.Litigation_Category }}
                </ng-template>
              </td>
              <td>
                <div style="display: flex; align-items: center; gap: 10px; white-space: nowrap;">
                  <button *ngIf="hasAppealCases(rowData)" type="button" pButton pRipple [pRowToggler]="rowData"
                    class="p-button-rounded p-button-info p-button-outlined custom-toggle-btn"
                    [icon]="expandedRowKeys[rowData._id] ? 'pi pi-minus' : 'pi pi-plus'"
                    style="width: 26px; height: 26px; flex-shrink: 0;">
                  </button>
                  <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 3px;">
                    <div style="display: flex; gap: 4px; flex-wrap: wrap;">
                      <p-tag *ngIf="rowData['Data Source'] === 'Pre 2017 Litigation Excel'" severity="warn"
                        value="Excel">
                      </p-tag>
                      <p-tag
                        *ngIf="rowData['Data Source'] === 'Other Litigations' || rowData['Data Source'] === 'other' || rowData['Data Source'] === 'Other' || rowData['Source'] === 'other' || rowData['Source'] === 'Other'"
                        severity="info" value="Other">
                      </p-tag>
                    </div>
                    <span class="fw-bold" style="color: #2c3e50;">{{ rowData['Case Number'] }}</span>
                  </div>
                </div>
              </td>
              <td>
                <ng-container
                  *ngIf="editRowId === rowData['_id'] && selectedOption === 'defendants_directory'; else viewMode">
                  <input type="text" [(ngModel)]="rowData['NDA Number']" placeholder="NDA Number"
                    style="width: 100px; margin-right: 5px; margin-bottom: 5px;" />
                  <input type="text" [(ngModel)]="rowData['Brand Name']" placeholder="Brand Name"
                    style="width: 150px;" />
                </ng-container>

                <ng-template #viewMode>
                  {{ rowData['NDA Number'] }}-{{ rowData['Brand Name'] }}
                </ng-template>
              </td>

              <!-- <td>
                <span *ngIf="editRowId === rowData['_id'] && selectedOption === 'defendants_directory'">
                  <input type="text" [(ngModel)]="rowData['NDA Number']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id'] || selectedOption !== 'defendants_directory'">
                  {{ rowData['NDA Number'] }}
                </span>
              </td>
              <td>
                <span *ngIf="editRowId === rowData['_id'] && selectedOption === 'defendants_directory'">
                  <input type="text" [(ngModel)]="rowData['Brand Name']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id'] || selectedOption !== 'defendants_directory'">
                  {{ rowData['Brand Name'] }}
                </span>
              </td> -->
              <td>{{ rowData['Plaintiff'] }}</td>
              <td>{{ rowData['Defendant'] }}</td>
              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Filed ANDA']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Filed ANDA'] }}
                </span>
              </td>

              <td class="anda-cell">
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['ANDA Number']" />
                </span>

                <span *ngIf="editRowId !== rowData['_id']">
                  <ng-container *ngFor="let a of getAndaLines(rowData['ANDA Number']); let last = last">
                    <span class="anda-item">{{ a }}{{ last ? '' : ',' }}</span>
                  </ng-container>

                  <ng-container *ngIf="!getAndaLines(rowData['ANDA Number']).length">
                    N/A
                  </ng-container>
                </span>
              </td>



              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Court Name']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Court Name'] }}
                </span>
              </td>
              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Judge']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Judge'] }}
                </span>
              </td>
              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Field ID']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Field ID'] }}
                </span>
              </td>
              <!-- <td style="max-width: 200px; word-wrap: break-word; white-space: normal;">
                {{ rowData['Patents at issue'] }}
              </td> -->
              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Patents at issue']" />
                </span>

                <span *ngIf="editRowId !== rowData['_id']">
                  <ng-container *ngIf="isArray(rowData['Patents at issue']); else showNA">
                    <ul style="margin: 0; padding-left: 15px;">
                      <li *ngFor="let patent of getFirstThreePatents(rowData['Patents at issue'])">{{ patent }}</li>
                    </ul>

                    <button style="font-size: 13px;" *ngIf="rowData['Patents at issue'].length > 3"
                      class="btn btn-link p-0" (click)="showPatentDialog(rowData)">
                      Show more
                    </button>
                  </ng-container>

                  <ng-template #showNA>
                    <span>N/A</span>
                  </ng-template>
                </span>
              </td>

              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Case Status']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Case Status'] }}
                </span>
              </td>

              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Related Cases']" />
                </span>

                <span *ngIf="editRowId !== rowData['_id']">
                  <ng-container
                    *ngIf="isArray(rowData['Related Cases']) && rowData['Related Cases'].length > 0; else showNA">
                    <button style="font-size: 13px;" class="btn btn-link p-0" (click)="showRelatedCasesDialog(rowData)">
                      Show more
                    </button>
                  </ng-container>

                  <ng-template #showNA>
                    <span>N/A</span>
                  </ng-template>
                </span>
              </td>

              <!-- <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Related Cases']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Related Cases'] }}
                </span>
              </td> -->
              <td>
                <span *ngIf="editRowId === rowData['_id']">
                  <input type="text" [(ngModel)]="rowData['Termination Date']" />
                </span>
                <span *ngIf="editRowId !== rowData['_id']">
                  {{ rowData['Termination Date'] }}
                </span>
              </td>
              <!-- <td style="max-width: 10px;"><button class="btn btn-primary btn-sm"
                  (click)="showPatentDialog(rowData)">View
                  Patents</button>
              </td> -->
              <td>
                <span *ngIf="editRowId === rowData['_id']">

                  <!-- Compact inline radio group -->
                  <div style="display:flex; align-items:center; gap:8px; flex-wrap:nowrap; white-space:nowrap;">

                    <label *ngIf="rowData['PDF File'] !== 'N/A' && rowData['PDF File']"
                      style="cursor:pointer; font-size:12px; display:flex; align-items:center; gap:3px;">
                      <input type="radio" name="pdfMode_{{rowData['_id']}}" value="keep" [(ngModel)]="editRowPdfMode"
                        (change)="listPDFFile = null" />
                      Keep
                    </label>

                    <label style="cursor:pointer; font-size:12px; display:flex; align-items:center; gap:3px;">
                      <input type="radio" name="pdfMode_{{rowData['_id']}}" value="upload" [(ngModel)]="editRowPdfMode"
                        (change)="listPDFFile = null" />
                      Upload
                    </label>

                    <label style="cursor:pointer; font-size:12px; display:flex; align-items:center; gap:3px;">
                      <input type="radio" name="pdfMode_{{rowData['_id']}}" value="na" [(ngModel)]="editRowPdfMode"
                        (change)="listPDFFile = null" />
                      N/A
                    </label>

                  </div>

                  <!-- File input: only when upload selected -->
                  <div *ngIf="editRowPdfMode === 'upload'" style="margin-top:4px;">
                    <input type="file" id="pdfUpload_{{rowData['_id']}}" accept="application/pdf"
                      (change)="onListPDFSelect($event)" style="font-size:11px; max-width:120px;" />
                    <small *ngIf="!listPDFFile" style="color:#e65100; font-size:11px; display:block;">
                      ⚠ Select a file
                    </small>
                  </div>

                  <!-- Status hint: single line, small -->
                  <small style="font-size:11px; display:block; margin-top:2px;"
                    [style.color]="editRowPdfMode === 'keep' ? '#2e7d32' : editRowPdfMode === 'na' ? '#e65100' : '#1565c0'">
                    {{ editRowPdfMode === 'keep' ? '✓ Keeping existing' : editRowPdfMode === 'na' ? '⚠ Will set N/A' :
                    listPDFFile ? ('✓ ' + listPDFFile.name) : '' }}
                  </small>

                </span>

                <!-- View mode unchanged -->
                <span *ngIf="editRowId !== rowData['_id']">
                  <a (click)="openPdf(rowData['PDF File'])" style="color: #007bff; cursor: pointer;"
                    *ngIf="rowData['PDF File'] != 'N/A'; else noPdf">View PDF</a>
                  <ng-template #noPdf>N/A</ng-template>
                </span>
              </td>
              <td *ngIf="selectedOption !== 'not_found_pdf_case_no' && selectedOption !== 'deleted'">
                <span *ngIf="editRowId !== rowData['_id']">
                  <button class="btn-primary" (click)="editRow(rowData)">Edit
                  </button>
                </span>
                <span *ngIf="editRowId === rowData['_id']">
                  <button class="btn-primary" (click)="saveRow(rowData)">Save
                  </button>
                </span>
              </td>
              <td>
                <button class="btn-danger" [ngClass]="{'faded-red': rowData['is_deleted'] === true}"
                  (click)="confirmDelete(rowData)" [disabled]="rowData['is_deleted'] === true">Delete
                </button>
              </td>
              <td *ngIf="selectedStatus === 'pending'">
                <button
                  (click)="onApproveReject(rowData['_id'], rowData['Case Number'], rowData['NDA Number'], rowData['Brand Name'], rowData['Plaintiff'], rowData['Filed ANDA'], rowData['ANDA Number'], 'approved', rowData)"
                  class="btn btn-success" [disabled]="rowData.isButtonDisabled"
                  [ngStyle]="{ 'cursor': rowData.isButtonDisabled ? 'not-allowed' : 'pointer' }"
                  style="margin-right: 10px; padding: 5px 10px; border-radius: 5px;">
                  <i class="fas fa-check"></i>
                </button>
              </td>
              <td style="white-space:nowrap;">
                <button class="btn btn-primary btn-sm" (click)="openAddCaseEvent(rowData)"
                  style="margin-right:6px;">Add</button>
                <button class="btn btn-warning btn-sm" (click)="openViewCaseEvents(rowData)">View</button>
              </td>
              <td style="text-align: center;">
                <button class="btn btn-success btn-sm" (click)="openAddAppealCase(rowData)">
                  Add
                </button>
              </td>
              <td *ngIf="rowData['is_deleted'] === true" style="white-space:nowrap;">
                <button type="button" label="Undo" class="btn btn-secondary btn-sm" (click)="confirmUndo(rowData)"> Undo
                </button>
              </td>
              <td>{{ rowData['approved_timestamp'] }}</td>
              <td>{{ rowData['edited_by'] }}</td>
              <td>{{ rowData['last_edited_date'] }}</td>
              <!-- <td>
                                <button [ngClass]="{'btn-disabled': rowData['onHold'] === true}" class="btn-warning"
                                    (click)="confirmOnHold(rowData)" [disabled]="rowData['onHold'] === true">Hold
                                </button>
                            </td> -->
            </tr>
          </ng-template>
          <ng-template pTemplate="rowexpansion" let-rowData>
            <tr>
              <td [attr.colspan]="getColSpan()">
                <div class="nested-table-container">
                  <div class="nested-header-section">
                    <i class="pi pi-info-circle" style="color: #3498db; margin-right: 8px;"></i>
                    <span class="nested-title">Appeal Case(s)</span>
                  </div>
                  <p-table [value]="getFilteredAppeals(rowData['AppealCases'])"
                    styleClass="p-datatable-sm p-datatable-gridlines custom-nested-table" [responsive]="true">
                    <ng-template pTemplate="header">
            <tr>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Case Number</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Court</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Appellant</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Filed Date</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Case Status</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Termination Date</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">PDF</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Events</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Approve/Reject</th>
              <th style="background-color: #e9ecef; color: #495057; font-weight: 600;">Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-appeal>
            <tr>
              <td>{{ appeal['Appeal Case Number'] || 'N/A' }}</td>
              <td>{{ appeal['Appeal Court'] || 'N/A' }}</td>
              <td>{{ appeal['Appellant'] || 'N/A' }}</td>
              <td>{{ appeal['Appeal Filed Date'] || 'N/A' }}</td>
              <td>{{ appeal['Appeal Case Status'] || 'N/A' }}</td>
              <td>{{ appeal['Appeal Termination Date'] || 'N/A' }}</td>
              <td>
                <a (click)="openPdf(appeal['Appeal PDF Path'])"
                  style="color: #007bff; cursor: pointer; text-decoration: underline;"
                  *ngIf="appeal['Appeal PDF Path'] != 'N/A' && appeal['Appeal PDF Path']; else noPdf">View PDF</a>
                <ng-template #noPdf>N/A</ng-template>
              </td>
              <td style="white-space:nowrap;">
                <button class="btn btn-primary btn-sm" (click)="openAddAppealCaseEvent(appeal, rowData)"
                  style="margin-right:6px;">Add</button>
                <button class="btn btn-warning btn-sm" (click)="openViewAppealCaseEvents(appeal, rowData)">View</button>
              </td>
              <td style="white-space:nowrap;">
                <button (click)="onAppealApproveReject(appeal, rowData, 'approved')" class="btn btn-success btn-sm"
                  [disabled]="appeal['Approve/Reject Status'] === 'approved' || appeal['Approve/Reject Status'] === 'rejected'"
                  style="margin-right: 10px; padding: 5px 10px; border-radius: 5px;"
                  [ngStyle]="{ 'cursor': (appeal['Approve/Reject Status'] === 'approved' || appeal['Approve/Reject Status'] === 'rejected') ? 'not-allowed' : 'pointer' }">
                  <i class="fas fa-check"></i>
                </button>
                <button (click)="onAppealApproveReject(appeal, rowData, 'rejected')" class="btn btn-danger btn-sm"
                  [disabled]="appeal['Approve/Reject Status'] === 'approved' || appeal['Approve/Reject Status'] === 'rejected'"
                  style="padding: 5px 10px; border-radius: 5px;"
                  [ngStyle]="{ 'cursor': (appeal['Approve/Reject Status'] === 'approved' || appeal['Approve/Reject Status'] === 'rejected') ? 'not-allowed' : 'pointer' }">
                  <i class="fas fa-times"></i>
                </button>
              </td>
              <td style="white-space: nowrap;">
                <ng-container
                  *ngIf="!((selectedOption === 'appeal_cases' || selectedOption === 'other_litigation_appeal_cases') && selectedStatus === 'deleted'); else undoAppeal">
                  <button type="button" class="btn btn-warning btn-sm" (click)="editAppealCase(appeal, rowData)"
                    style="margin-right: 5px;">Edit</button>
                  <button type="button" class="btn btn-danger btn-sm"
                    (click)="confirmDeleteAppeal(appeal, rowData)">Delete</button>
                </ng-container>
                <ng-template #undoAppeal>
                  <span class="badge bg-danger" style="color: white; margin-right: 5px;">Deleted</span>
                  <button type="button" class="btn btn-secondary btn-sm"
                    (click)="confirmUndoAppeal(appeal, rowData)">Undo</button>
                </ng-template>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      </td>
      </tr>
      </ng-template>
      </p-table>
    </div>

    <p-dialog header="Confirm Undo" [(visible)]="displayUndoDialog" [modal]="true" [style]="{ width: '400px' }">

      <p>Are you sure you want to restore this deleted record?</p>

      <ng-template pTemplate="footer">
        <button pButton label="No" class="p-button-text" (click)="displayUndoDialog=false">
        </button>

        <button pButton label="Yes, Undo" class="p-button-success" (click)="undoDeletedRecord()">
        </button>
      </ng-template>

    </p-dialog>


    <p-dialog header="Patents at Issue" [(visible)]="displayPatentDialog" [modal]="true" [style]="{ width: '50vw' }"
      [closable]="true">
      <div style="max-height: 400px; overflow-y: auto;">
        <ng-container *ngIf="selectedPatents && selectedPatents.length; else noPatents">
          <ul>
            <li *ngFor="let patent of selectedPatents">{{ patent }}</li>
          </ul>
        </ng-container>

        <ng-template #noPatents>
          <p>N/A</p>
        </ng-template>
      </div>
    </p-dialog>

    <p-dialog header="Related Cases" [(visible)]="displayRelatedDialog" [modal]="true" [style]="{ width: '50vw' }"
      [closable]="true">
      <div style="max-height: 400px; overflow-y: auto;">
        <ng-container *ngIf="selectedRelatedCases && selectedRelatedCases.length; else noRelatedCases">
          <ul>
            <li *ngFor="let item of selectedRelatedCases">{{ item }}</li>
          </ul>
        </ng-container>
        <ng-template #noRelatedCases>
          <p>N/A</p>
        </ng-template>
      </div>
    </p-dialog>

    <p-dialog header="Confirm Undo Appeal" [(visible)]="displayUndoAppealDialog" [modal]="true"
      [style]="{ width: '400px' }">
      <p>Are you sure you want to restore this deleted appeal case?</p>
      <ng-template pTemplate="footer">
        <button pButton label="No" class="p-button-text" (click)="displayUndoAppealDialog=false"></button>
        <button pButton label="Yes, Undo" class="p-button-success" (click)="undoAppealCase()"></button>
      </ng-template>
    </p-dialog>

    <p-dialog header="Confirm Delete" [(visible)]="displayDeleteDialog" [modal]="true" [closable]="false">
      <p>Are you sure you want to delete this record?</p>
      <p-footer>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="displayDeleteDialog = false"></button>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="deleteRecord()"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="Confirm Reject" [(visible)]="displayBulkRejectDialog" [modal]="true" [closable]="false">
      <p>Are you sure you want to reject selected records?</p>
      <p-footer>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="displayBulkRejectDialog = false"></button>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="rejectSelectedRecords()"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="Confirm On Hold" [(visible)]="displayBulkHoldDialog" [modal]="true" [closable]="false">
      <p>Are you sure you want to place the selected records on hold?</p>
      <p-footer>
        <button type="button" pButton icon="pi pi-times" label="No" (click)="displayBulkHoldDialog = false"></button>
        <button type="button" pButton icon="pi pi-check" label="Yes" (click)="bulkHoldSelectedRecords()"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="Manage Events" [(visible)]="displayEventManager" [modal]="true" [closable]="true"
      [style]="{width:'600px'}">
      <div class="mb-3">
        <label class="form-label fw-bold">Add New Event</label>
        <div class="d-flex" style="gap:8px;">
          <input pInputText type="text" class="form-control" [(ngModel)]="newEventName"
            placeholder="Enter new event name" />
          <button class="btn btn-primary" (click)="addNewEventName()">Add</button>
        </div>
      </div>

      <hr />

      <div>
        <h6 class="fw-bold mb-2"><i class="pi pi-calendar" style="margin-right:6px;"></i>Current Events</h6>
        <div class="table-responsive">
          <table class="table table-bordered mb-0">
            <thead>
              <tr>
                <th>Event</th>
                <th style="width:120px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ev of eventsMaster">
                <td *ngIf="editEventId !== ev._id">{{ ev.name }}</td>
                <td *ngIf="editEventId === ev._id">
                  <input pInputText class="form-control" [(ngModel)]="editEventName" />
                </td>
                <td style="white-space:nowrap;">
                  <button *ngIf="editEventId !== ev._id" class="btn btn-warning btn-sm"
                    (click)="startEditEvent(ev)">Edit</button>
                  <button *ngIf="editEventId === ev._id" class="btn btn-primary btn-sm"
                    (click)="saveEditEvent()">Save</button>
                </td>
              </tr>
              <tr *ngIf="!eventsMaster?.length">
                <td colspan="2" class="text-center">No events found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </p-dialog>

    <p-dialog header="Manage Appeal Case Events" [(visible)]="displayAppealEventManager" [modal]="true"
      [closable]="true" [style]="{width:'600px'}">
      <div class="mb-3">
        <label class="form-label fw-bold">Add New Appeal Event</label>
        <div class="d-flex" style="gap:8px;">
          <input pInputText type="text" class="form-control" [(ngModel)]="newAppealEventName"
            placeholder="Enter new appeal event name" />
          <button class="btn btn-primary" (click)="addNewAppealEventName()">Add</button>
        </div>
      </div>

      <hr />

      <div>
        <h6 class="fw-bold mb-2"><i class="pi pi-calendar" style="margin-right:6px;"></i>Current Appeal Events</h6>
        <div class="table-responsive">
          <table class="table table-bordered mb-0">
            <thead>
              <tr>
                <th>Event</th>
                <th style="width:120px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ev of appealEventsMaster">
                <td *ngIf="editAppealEventId !== ev._id">{{ ev.name }}</td>
                <td *ngIf="editAppealEventId === ev._id">
                  <input pInputText class="form-control" [(ngModel)]="editAppealEventName" />
                </td>
                <td style="white-space:nowrap;">
                  <button *ngIf="editAppealEventId !== ev._id" class="btn btn-warning btn-sm"
                    (click)="startEditAppealEvent(ev)">Edit</button>
                  <button *ngIf="editAppealEventId === ev._id" class="btn btn-primary btn-sm"
                    (click)="saveEditAppealEvent()">Save</button>
                </td>
              </tr>
              <tr *ngIf="!appealEventsMaster?.length">
                <td colspan="2" class="text-center">No appeal events found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </p-dialog>

    <p-dialog header="Add Events" [(visible)]="displayAddCaseEvent" [modal]="true" [closable]="true"
      [style]="{width:'480px'}" [contentStyle]="{ overflow: 'visible' }">
      <div class="mb-3">
        <label class="form-label">Date</label>
        <input type="date" class="form-control" [(ngModel)]="caseEventDate" />
      </div>

      <div class="mb-3">
        <label class="form-label">Events</label>
        <p-dropdown [options]="eventsOptions" [(ngModel)]="caseEventName" placeholder="Select Event" [filter]="true"
          [appendTo]="'body'" [autoZIndex]="true" [baseZIndex]="1100" [style]="{ width: '100%' }"
          [panelStyle]="{ minWidth: '100%', maxHeight: '300px' }"> </p-dropdown>
      </div>

      <div class="mb-3">
        <label class="form-label">Upload Attachment (PDF)</label>
        <input #caseEventFile type="file" accept="application/pdf" class="form-control"
          (change)="onCaseEventPdfPicked($event)" />
        <small *ngIf="caseEventPdf">Selected: {{ caseEventPdf?.name }}</small>
      </div>

      <p-footer>
        <button type="button" pButton label="Cancel" class="cancel-btn" (click)="displayAddCaseEvent=false"></button>
        <button type="button" pButton label="Save" class="submit-btn" (click)="saveCaseEvent()"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="View Events" [(visible)]="displayViewCaseEvents" [modal]="true" [closable]="true"
      [style]="{width:'600px'}">
      <div class="table-responsive" style="max-height:360px; overflow:auto;">
        <table class="table table-bordered mb-0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Event</th>
              <th>View PDF</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of caseEventsForView | slice:0">
              <td>{{ r?.event_date }}</td>
              <td>{{ r?.event_name }}</td>
              <td>
                <ng-container *ngIf="r?.attachment; else noAttachment">
                  <button class="btn btn-link p-0" (click)="openPdf(r.attachment)">
                    <i class="pi pi-file-pdf"></i>
                  </button>
                </ng-container>

                <ng-template #noAttachment>
                  N/A
                </ng-template>
              </td>
              <td>
                <button class="btn btn-danger btn-sm" (click)="confirmDeleteCaseEvent(r)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!caseEventsForView?.length">
              <td colspan="4" class="text-center">No events available.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </p-dialog>

    <p-dialog header="Confirm Delete Case Event" [(visible)]="displayDeleteCaseEventDialog" [modal]="true"
      [closable]="true" [style]="{width:'400px'}">
      <div class="text-center">
        <p>Are you sure you want to delete this case event?</p>
        <div class="mt-3">
          <button type="button" class="btn btn-secondary mr-2"
            (click)="displayDeleteCaseEventDialog=false">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="deleteCaseEvent()">Yes</button>
        </div>
      </div>
    </p-dialog>

    <p-dialog [header]="isEditAppeal ? 'Edit Appeal Case' : 'Add Appeal Case'" [(visible)]="displayAddAppealDialog"
      [modal]="true" [closable]="true" [style]="{width:'500px'}"
      [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }">
      <div class="p-fluid">
        <div class="mb-3">
          <label class="form-label fw-bold">Appeal Case Number</label>
          <input type="text" pInputText class="form-control" [(ngModel)]="appealCaseNumber" placeholder="e.g. 11-1585"
            [disabled]="isEditAppeal" />
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Appeal Court</label>
          <input type="text" pInputText class="form-control" [(ngModel)]="appealCourt"
            placeholder="e.g. Federal Circuit" />
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Appellant</label>
          <input type="text" pInputText class="form-control" [(ngModel)]="appellantForm"
            placeholder="e.gac. Dr. Reddy's Laboratories" />
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Appeal Filed Date</label>
          <input type="date" class="form-control" [(ngModel)]="appealFiledDate" />
        </div>

        <div class="mb-3">
          <label class="form-label fw-bold">Appeal Case Status</label>
          <p-dropdown [options]="appealStatusOptions" [(ngModel)]="appealCaseStatus" placeholder="Select Status"
            (onChange)="onAppealStatusChange()"></p-dropdown>
        </div>

        <!-- Appeal Termination Date -->
        <div class="mb-4" style="background: #f8fafc; padding: 15px; border-radius: 10px; border: 1px solid #e2e8f0;">
          <label class="form-label fw-bold d-flex align-items-center mb-2" style="color: #475569;">
            Appeal Termination Date
          </label>
          <div *ngIf="appealCaseStatus === 'Closed'">
            <input type="date" class="form-control" [(ngModel)]="appealTerminationDate" />
          </div>
          <div *ngIf="appealCaseStatus === 'Open'" class="input-group">
            <input type="text" class="form-control border-start-0" value="N/A" disabled />
          </div>
          <div *ngIf="!appealCaseStatus" class="text-muted italic">
            <small>Select status to set termination date</small>
          </div>
        </div>

        <!-- Appeal PDF -->
        <div class="mb-4" style="background: #f8fafc; padding: 15px; border-radius: 10px; border: 1px solid #e2e8f0;">
          <label class="form-label fw-bold d-flex align-items-center mb-2" style="color: #475569;">
            Appeal PDF
          </label>

          <div class="d-flex mb-3 px-1 flex-wrap" style="gap: 30px;">
            <div
              *ngIf="isEditAppeal && activeAppealToEdit?.['Appeal PDF Path'] && activeAppealToEdit?.['Appeal PDF Path'] !== 'N/A'"
              class="form-check d-flex align-items-center gap-2">
              <input class="form-check-input mt-0" type="radio" name="appealPdfMode" id="pdfKeep" value="keep"
                [(ngModel)]="appealPdfMode" style="cursor: pointer;">
              <label class="form-check-label mb-0" for="pdfKeep"
                style="cursor: pointer; font-size: 14px; user-select: none;">Keep Existing</label>
            </div>
            <div class="form-check d-flex align-items-center gap-2">
              <input class="form-check-input mt-0" type="radio" name="appealPdfMode" id="pdfUpload" value="upload"
                [(ngModel)]="appealPdfMode" style="cursor: pointer;">
              <label class="form-check-label mb-0" for="pdfUpload"
                style="cursor: pointer; font-size: 14px; user-select: none;">Upload New</label>
            </div>
            <div class="form-check d-flex align-items-center gap-2">
              <input class="form-check-input mt-0" type="radio" name="appealPdfMode" id="pdfNA" value="na"
                [(ngModel)]="appealPdfMode" style="cursor: pointer;">
              <label class="form-check-label mb-0" for="pdfNA"
                style="cursor: pointer; font-size: 14px; user-select: none; color: #b91c1c;">Remove (N/A)</label>
            </div>
          </div>

          <div *ngIf="appealPdfMode === 'upload'" class="bg-white p-2 border rounded"
            style="border-style: dashed !important;">
            <input #appealFileInput type="file" accept="application/pdf" class="form-control"
              (change)="onAppealPdfSelect($event)" />
            <small *ngIf="appealPdfFile" class="text-success mt-2 d-flex align-items-center px-1">
              <i class="pi pi-check-circle me-1"></i> Selected: {{ appealPdfFile.name }}
            </small>
          </div>

          <div *ngIf="appealPdfMode === 'keep' && isEditAppeal"
            class="bg-white p-2 border rounded d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center overflow-hidden">
              <i class="pi pi-file-pdf text-danger fs-5 me-2"></i>
              <small class="text-muted text-truncate" style="max-width: 280px;">{{ activeAppealToEdit['Appeal PDF Path']
                }}</small>
            </div>
            <button type="button" class="btn btn-link btn-sm p-0 ms-2 text-decoration-none d-flex align-items-center"
              (click)="openPdf(activeAppealToEdit['Appeal PDF Path'])">
              <i class="pi pi-external-link me-1"></i> View
            </button>
          </div>

          <div *ngIf="appealPdfMode === 'na'" class="p-2 border rounded d-flex align-items-center"
            style="background: #fff1f2; border-color: #fecaca; color: #991b1b;">
            <small class="fw-medium"> The PDF record will be marked as N/A.</small>
          </div>
        </div>
      </div>

      <p-footer>
        <button type="button" pButton label="Cancel" class="p-button-text"
          (click)="displayAddAppealDialog=false"></button>
        <button type="button" pButton [label]="loading ? 'Saving...' : 'Save'" icon="pi pi-check"
          (click)="saveAppealCase()" [disabled]="loading"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="Confirm Delete" [(visible)]="displayDeleteAppealDialog" [modal]="true" [closable]="true"
      [style]="{width:'350px'}">
      <p><i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #f0ad4e; vertical-align: middle;"></i> Are
        you sure you want to delete this appeal case?</p>
      <p-footer>
        <button type="button" pButton label="No" class="p-button-text"
          (click)="displayDeleteAppealDialog=false"></button>
        <button type="button" pButton label="Yes" class="p-button-danger" (click)="deleteAppealCase()"></button>
      </p-footer>
    </p-dialog>
    <p-dialog header="Add Appeal Case Events" [(visible)]="displayAppealAddCaseEvent" [modal]="true" [closable]="true"
      [style]="{width:'480px'}" [contentStyle]="{ overflow: 'visible' }">
      <div class="mb-3">
        <label class="form-label">Date</label>
        <input type="date" class="form-control" [(ngModel)]="appealCaseEventDate" />
      </div>

      <div class="mb-3">
        <label class="form-label">Events</label>
        <p-dropdown [options]="appealEventsOptions" [(ngModel)]="appealCaseEventName" placeholder="Select Event"
          [filter]="true" [appendTo]="'body'" [style]="{ width: '100%' }">
        </p-dropdown>
      </div>

      <div class="mb-3">
        <label class="form-label">Upload Attachment (PDF)</label>
        <input #appealCaseEventFile type="file" accept="application/pdf" class="form-control"
          (change)="onAppealCaseEventPdfPicked($event)" />
        <small *ngIf="appealCaseEventPdf">Selected: {{ appealCaseEventPdf?.name }}</small>
      </div>

      <p-footer>
        <button type="button" pButton label="Cancel" class="cancel-btn"
          (click)="displayAppealAddCaseEvent=false"></button>
        <button type="button" pButton label="Save" class="submit-btn" (click)="saveAppealCaseEvent()"></button>
      </p-footer>
    </p-dialog>

    <p-dialog header="View Appeal Case Events" [(visible)]="displayAppealViewCaseEvents" [modal]="true"
      [closable]="true" [style]="{width:'600px'}">
      <div class="table-responsive" style="max-height:360px; overflow:auto;">
        <table class="table table-bordered mb-0">
          <thead>
            <tr>
              <th>Date</th>
              <th>Event</th>
              <th>View PDF</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ev of appealCaseEventsForView">
              <td>{{ ev.event_date }}</td>
              <td>{{ ev.event_name }}</td>
              <td>
                <a (click)="openCaseEventPdf(ev.attachment)" style="color: #007bff; cursor: pointer; margin-right:12px;"
                  *ngIf="ev.attachment && ev.attachment !== 'N/A'; else noPdf"><i class="pi pi-file-pdf"></i></a>
                <ng-template #noPdf><span style="margin-right:12px;">N/A</span></ng-template>
              </td>
              <td>
                <button class="btn btn-danger btn-sm" (click)="confirmDeleteAppealCaseEvent(ev)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!appealCaseEventsForView || appealCaseEventsForView.length === 0">
              <td colspan="4" class="text-center">No events found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </p-dialog>

    <p-dialog header="Confirm Delete Appeal Event" [(visible)]="displayDeleteAppealCaseEventDialog" [modal]="true"
      [closable]="true" [style]="{width:'350px'}">
      <p><i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #f0ad4e; vertical-align: middle;"></i>
        Are you sure you want to delete this appeal case event?</p>
      <p-footer>
        <button type="button" class="btn btn-secondary mr-2"
          (click)="displayDeleteAppealCaseEventDialog=false">Cancel</button>
        <button type="button" class="btn btn-danger" (click)="deleteAppealCaseEvent()">Yes</button>
      </p-footer>
    </p-dialog>
</div>
</ng-container>
</div>